var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAdd)?_c('div',[(_vm.productMainView == 'cartactions')?_c('button',{staticClass:"cta-btn cta-btn-sm",on:{"click":_vm.addToCart}},[_vm._v(" Buy Now")]):_c('button',{staticClass:"cta-btn",on:{"click":_vm.addToCart}},[_vm._v(" Buy Now")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eedd5116","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ProductCTAActions.vue
// module id = 203
// module chunks = 0